import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IProfile } from '../UserDetails/user.model'
@Injectable()
export class UserProfile {
    userProfile: IProfile = {
        access_token: "",
        expires_in: "",
        Id:"",
        firstName: "",
        emailId:"",
        phoneNumber:"" 
    };
    constructor(private router: Router) {
    }
    setProfile(profile: IProfile): void {    
       
        localStorage.setItem('access_token', profile.access_token);
        localStorage.setItem('expires_in', profile.expires_in);
        localStorage.setItem('Id', profile.Id);
        localStorage.setItem('firstName', profile.firstName);               
        localStorage.setItem('emailId', profile.emailId);
        localStorage.setItem('phoneNumber', profile.phoneNumber);     
    }

    getProfile(authorizationOnly: boolean = false): IProfile {
        var accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            this.userProfile.access_token = accessToken;
            this.userProfile.expires_in = localStorage.getItem('expires_in');
        }
        return this.userProfile;
    }

    resetProfile(): IProfile {
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_in');
        localStorage.removeItem('Id');
        localStorage.removeItem('firstName');
        localStorage.removeItem('emailId');
        localStorage.removeItem('phoneNumber');
        localStorage.removeItem('patient id');
        this.userProfile = {
            access_token: "",
            expires_in: "",
            Id:"",
            firstName:"", 
            emailId:"", 
            phoneNumber:""
        };
        return this.userProfile;
    }
}